// --- components/RevenueChart.jsx ---
import {
  ResponsiveContainer,
  AreaChart,
  Area,
  XAxis,
  YAxis,
  Tooltip,
  CartesianGrid,
} from "recharts";
import { useState } from "react";

export default function LinechartComp({ revenueTrends }) {
  const [activePoint, setActivePoint] = useState(null);
  const chartData = revenueTrends || [];

  const handleClick = (e) => {
      e?.preventDefault?.();
  e?.stopPropagation?.();
  document.activeElement?.blur();
     setActivePoint(chartData[e.activeIndex]);
  };

  return (
    <div className="h-auto w-full space-y-4 ">
      <div className="h-80">
        <ResponsiveContainer>
          <AreaChart
            data={chartData}
            margin={{ top: 10, right: 30, left: 20, bottom: 0 }}
            onClick={handleClick}
          >
            <defs>
              <linearGradient id="areaGradient" x1="0" y1="0" x2="0" y2="1">
                <stop offset="0%" stopColor="#3383B2" stopOpacity={0.3} />
                <stop offset="100%" stopColor="#3383B2" stopOpacity={0} />
              </linearGradient>
            </defs>

            <CartesianGrid 
              strokeDasharray="4 4"      
              stroke="#CBD5E0"           
              strokeWidth={1.2} 
               />
            <XAxis
              dataKey="name"
              tick={{ fill: "#2D3748", fontSize: 12, fontWeight: 500 }}
              axisLine={{ stroke: "#A0AEC0", strokeWidth: 1.5 }} 
              tickLine={{ stroke: "#A0AEC0", strokeWidth: 1 }} 
            />
            <YAxis 
             dataKey="value"
             tick={{ fill: "#2D3748", fontSize: 12, fontWeight: 500 }}
              axisLine={{ stroke: "#A0AEC0", strokeWidth: 1.5 }}
              tickLine={{ stroke: "#A0AEC0", strokeWidth: 1 }}  />
            <Tooltip cursor={false} />
            <Area
              type="monotone"
              dataKey="value"
              stroke="#3383B2"
              fill="url(#areaGradient)"
              strokeWidth={3}
              dot={false}
              isAnimationActive={false}
            />
          </AreaChart>
        </ResponsiveContainer>
      </div>
{/* 
 {activePoint && (
        <div className="bg-gray-100 p-4 rounded-lg shadow-inner">
          <div className="flex justify-between mb-2">
            <h3 className="font-semibold text-lg">Details for {activePoint.name}</h3>
            <button className="text-sm text-red-600" onClick={() => setActivePoint(null)}>
              Close
            </button>
          </div>
          <ul className="text-sm list-disc pl-5 space-y-1">
            {activePoint.details?.map((item) => (
              <li key={item.id}>
                Order ID: {item.orderId}, Amount: {item.amount}, Date: {item.date}
              </li>
            ))}
          </ul>
        </div>
      )} */}

    </div>
  );
}
